module.exports = __webpack_public_path__ + "static/startup1-c6be1188409f822735247a3219547903.png";